import Vue from 'vue'
import gql from 'graphql-tag'
import { apolloClient } from '@/apollo'

const getAllNewMarketplace = gql`
  query getAllNewMarketplace($limit: Int, $offset: Int, $where: news_marketplace_bool_exp) {
    news_marketplace_aggregate(where: $where) {
      aggregate {
        count
      }
    }
    news_marketplace(order_by: {published_at: asc}, limit: $limit, offset: $offset, where: $where) {
      created_at,
      id,
      title,
      is_active,
      published_at,
      updated_at
      is_popup,
      show_every_ms,
      auto_close_delay_ms,
      news_translations_marketplaces(distinct_on:id) {
        content,
        id,
        language_code,
        news_marketplace_id,
      }
    }
  }
`

const createNewsMarketplaceGql = gql`
  mutation createNewsMarketplaceGql($newsData: news_marketplace_insert_input!) {
    insert_news_marketplace(objects: [$newsData]) {
      affected_rows
      returning {
        id
      }
    }
  }
`

const checkActivePopupExistsGql = gql`
  query checkActivePopupExists($excludeId: uuid) {
    news_marketplace(where: {
      is_active: { _eq: true },
      is_popup: { _eq: true },
      id: { _neq: $excludeId }
    }) {
      id
      title
    }
  }
`

const updateNewsMarketplaceGql = gql`
  mutation updateNewsMarketplaceAndTranslations(
  $newsId: uuid!,
  $isActive: Boolean!,
  $title: String!,
  $isPopup: Boolean!,
  $showEveryMs: Int,
  $autoCloseDelayMs: Int,
  $publishedAt: date!,
  $updatehedAt: date!,
  $translationEnContent: String!,
  $translationEsContent: String!
) {
  # Actualizar el registro principal de news_marketplace
  update_news_marketplace(
    where: { id: { _eq: $newsId } },
    _set: { is_active: $isActive, is_popup: $isPopup, show_every_ms: $showEveryMs, auto_close_delay_ms: $autoCloseDelayMs, published_at: $publishedAt, updated_at: $updatehedAt, title: $title }
  ) {
    returning {
      id
      is_active
      is_popup
      show_every_ms
      auto_close_delay_ms
      published_at
    }
  }

  update_translation_en: update_news_translations_marketplace(
    where: {
      news_marketplace_id: { _eq: $newsId },
      language_code: { _eq: "en" }
    },
    _set: { content: $translationEnContent }
  ) {
    returning {
      id
      language_code
      content
    }
  }

  update_translation_es: update_news_translations_marketplace(
    where: {
      news_marketplace_id: { _eq: $newsId },
      language_code: { _eq: "es" }
    },
    _set: { content: $translationEsContent }
  ) {
    returning {
      id
      language_code
      content
    }
  }
}

`

const newsMarketplace = {
  namespaced: true,
  state: {
    newsMarketplace: []
  },
  actions: {
    async checkActivePopupExists (_, excludeId = null) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: checkActivePopupExistsGql,
          variables: { excludeId }
        })
        if (response && response.data && response.data.news_marketplace) {
          return response.data.news_marketplace.length > 0
        }
        return false
      } catch (error) {
        console.error(error)
        return false
      }
    },
    async createNewsMarketplace ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: createNewsMarketplaceGql,
          variables
        })
        if (response && response.data && response.data) {
          dispatch('fetchAllNews')
          return response.data
        }
        throw new Error('Error al crear las noticias')
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },
    async updateNewsMarketplace ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: updateNewsMarketplaceGql,
          variables
        })
        if (response && response.data && response.data) {
          dispatch('fetchAllNews')
          return response.data
        }
        throw new Error('Error al actualizar las noticias')
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },
    async fetchAllNews ({ state }, variables) {
      try {
        const { limit, offset, filterPopup } = variables
        const where = filterPopup ? { is_popup: { _eq: true } } : {}

        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: getAllNewMarketplace,
          variables: {
            limit,
            offset,
            where
          }
        })

        if (response && response.data && response.data.news_marketplace) {
          Vue.set(state, 'newsMarketplace', response.data.news_marketplace)
          return response.data
        }
      } catch (error) {
        console.error(error)
        return error
      }
    }
  }
}

export default newsMarketplace



// WEBPACK FOOTER //
// ./src/store/modules/newsMarketplace.js